import Cropper from "cropperjs";
import "cropperjs/dist/cropper.css";
import { base64ToFile } from "@/jsUtils/tools/handle.js";
import bootstrap from '@/jsUtils/plugins/bootstrap4.0.0/bootstrap5.0.2.min.js';
import { default_max_width } from "@/globalcfg";
export default {
  name: "CropperImg",
  props: {
    widthheight_ratio: {
      type: Number,
      default: 1
    },
    isShowCropShape: {
      type: Boolean,
      default: false
    },
    crop_resizeSquare: {
      type: Object,
      default: null
    },
    crop_horizontal: {
      type: Object,
      default: null
    },
    crop_vertical: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      cropper: null,
      // 临时生成裁剪实例
      cropperInstance: null,
      // 裁剪实例

      modal: $('#crop-modal'),
      // 裁剪框

      width: 90,
      // 宽度
      height: 90,
      // 高度
      cropBoxConfig: [],
      // 裁剪框配置
      currentCfgIndex: 0,
      // 当前配置索引

      ratio: 1,
      // 裁剪比例
      aspectRatio: NaN,
      // 固定宽高比
      cropBoxResizable: true,
      // 是否可以调整裁剪框大小
      autoCropArea: 0.7,
      // 裁剪框自动缩放比例

      isCropModalVisible: false // 裁剪框是否可见
    };
  },

  mounted() {
    this.init();
  },
  computed: {
    getClientHeight() {
      let clientHeight = document.documentElement.clientHeight;
      clientHeight = clientHeight * 0.8;
      return clientHeight + 'px';
    }
  },
  watch: {
    // 监听三种裁剪形状的变更，动态同步到内部配置
    crop_resizeSquare: {
      deep: true,
      handler(val) {
        if (!val) return;
        if (!this.cropBoxConfig || this.cropBoxConfig.length < 1) return;
        this.cropBoxConfig[0].width = val.width;
        this.cropBoxConfig[0].height = val.height;
      }
    },
    crop_horizontal: {
      deep: true,
      handler(val) {
        if (!val) return;
        if (!this.cropBoxConfig || this.cropBoxConfig.length < 2) return;
        this.cropBoxConfig[1].width = val.width;
        this.cropBoxConfig[1].height = val.height;
      }
    },
    crop_vertical: {
      deep: true,
      handler(val) {
        if (!val) return;
        if (!this.cropBoxConfig || this.cropBoxConfig.length < 3) return;
        this.cropBoxConfig[2].width = val.width;
        this.cropBoxConfig[2].height = val.height;
      }
    }
  },
  methods: {
    // 将来自 props 的形状宽高同步到内部 cropBoxConfig
    syncCropConfigFromProps() {
      // 确保 cropBoxConfig 已初始化
      if (!this.cropBoxConfig || this.cropBoxConfig.length < 3) {
        return;
      }
      if (this.crop_resizeSquare) {
        this.cropBoxConfig[0].width = this.crop_resizeSquare.width;
        this.cropBoxConfig[0].height = this.crop_resizeSquare.height;
      }
      if (this.crop_horizontal) {
        this.cropBoxConfig[1].width = this.crop_horizontal.width;
        this.cropBoxConfig[1].height = this.crop_horizontal.height;
      }
      if (this.crop_vertical) {
        this.cropBoxConfig[2].width = this.crop_vertical.width;
        this.cropBoxConfig[2].height = this.crop_vertical.height;
      }
    },
    init() {
      this.cropBoxConfig = [{
        width: this.width,
        height: this.height,
        width_chunk: this.width / 8,
        height_chunk: this.height / 8
      }, {
        width: 0,
        height: 0,
        width_chunk: 0,
        height_chunk: 0
      }, {
        width: 0,
        height: 0,
        width_chunk: 0,
        height_chunk: 0
      }];

      // 和下面的选择窗口对应，0是正方形，1是横向，2是纵向
      if (this.crop_resizeSquare != null) {
        this.cropBoxConfig[0].width = this.crop_resizeSquare.width;
        this.cropBoxConfig[0].height = this.crop_resizeSquare.height;
      }
      if (this.crop_horizontal != null) {
        this.cropBoxConfig[1].width = this.crop_horizontal.width;
        this.cropBoxConfig[1].height = this.crop_horizontal.height;
      }
      if (this.crop_vertical != null) {
        this.cropBoxConfig[2].width = this.crop_vertical.width;
        this.cropBoxConfig[2].height = this.crop_vertical.height;
      }

      // 监听窗口变化
      window.onresize = () => {
        // 统一通过函数调整，并应用最小/最大高度
        this.adjustModalFooterImageHeight();
      };

      // 初始化宽度
      let clientwidth = document.documentElement.clientWidth;
      if (clientwidth > default_max_width) {
        clientwidth = default_max_width;
        this.$refs.modal_dialog.style.width = clientwidth * 0.9 + "px";
      }
      if (this.isShowCropShape == true) {
        this.currentCfgIndex = 0;
        if (this.cropperInstance != null) {
          this.cropperInstance.setAspectRatio(1);
        }
        document.getElementById('crop_resizeSquare').classList.add('highlight');
        document.getElementById('crop_horizontal').classList.remove('highlight');
        document.getElementById('crop_vertical').classList.remove('highlight');
      }
    },
    save() {
      this.cropperInstance.getCroppedCanvas().toBlob(blob => {
        this.$emit('save', blob);
      });
    },
    //开始裁剪
    onStartCrop(image) {
      // 每次开始裁剪前，同步一次 props 到内部配置，避免动态切换产品导致残留默认值
      this.syncCropConfigFromProps();
      let modalheight = '500px';
      let modalcontent = document.getElementsByClassName('crop-modal-content');
      // modalcontent.style.height = modalheight;

      //裁剪图片
      let imgUrl = image;

      // this.originimg = image;
      //先裁剪，打开裁剪面板
      let crop_image = document.getElementById('crop_image');
      crop_image.src = imgUrl;

      // let crop_modal = $('#crop-modal');
      let crop_modalEl = document.getElementById('crop-modal');
      let crop_modal = new bootstrap.Modal(document.getElementById('crop-modal'));

      // console.log("start crop----");
      // console.dir(this.modal);
      // console.dir(this.widthheight_ratio);
      // console.dir(image);

      let natureWidth = crop_image.naturalWidth;
      let natureHeight = crop_image.naturalHeight;
      let ratio = natureWidth / natureHeight;

      // 父组件传入的宽高比大于0，使用父组件传入的宽高比
      if (this.widthheight_ratio > 0 && this.widthheight_ratio <= 1) {
        ratio = this.widthheight_ratio;
        this.aspectRatio = ratio;
      } else if (-1 == this.widthheight_ratio) {
        // 父组件传入的宽高比为-1，自由裁剪
        ratio = natureWidth / natureHeight;
        this.aspectRatio = NaN;
      } else if (-2 == this.widthheight_ratio) {
        // 父组件传入的宽高比为-2，不裁剪，直接使用原图
        ratio = natureWidth / natureHeight;
        ratio = NaN;
        this.aspectRatio = NaN;
        this.cropBoxResizable = false;
        this.autoCropArea = 1;
      }
      this.ratio = ratio;

      // console.log(" before crop  ratio:" + this.ratio + " aspectRatio:" + this.aspectRatio +
      // 			 " cropBoxResizable:" + this.cropBoxResizable + " autoCropArea:" + this.autoCropArea +
      // 			 " naturewidth " + natureWidth + " natureheight " + natureHeight );

      let vm = this;

      //当裁剪面板打开        
      crop_modalEl.addEventListener('shown.bs.modal', function () {
        let modalObj = $(this).find('.modal-content');

        // let ration = crop_image.naturalWidth/crop_image.naturalHeight;
        // vm.ratio = ration;
        // console.log("ratio:" + vm.ratio + " width:" + crop_image.naturalWidth + " height:" + crop_image.naturalHeight
        //             + "aspectRatio:" + vm.aspectRatio + " cropBoxResizable:" + vm.cropBoxResizable 
        // 			+ " autoCropArea:" + vm.autoCropArea );

        let tempcropper = new Cropper(crop_image, {
          dragMode: 'move',
          initialAspectRatio: vm.ratio,
          aspectRatio: vm.aspectRatio,
          background: true,
          autoCropArea: vm.autoCropArea,
          // minCropBoxWidth: 80,
          // minCropBoxHeight: 80,
          cropBoxResizable: vm.cropBoxResizable,
          //cropBoxMovable: false,
          toggleDragModeOnDblclick: false,
          viewMode: 2,
          ready() {
            vm.cropperInstance = tempcropper;
          }
        });
        vm.adjustModalFooterImageHeight();

        //当前配置索引恢复为默认值
        if (vm.isShowCropShape == true) {
          vm.onSelectSquare();
        }

        // crop_modal.off('shown.bs.modal');//去除绑定,这个是bootstrap的bug

        vm.isCropModalVisible = true;
      });
      crop_modalEl.addEventListener('hidden.bs.modal', function () {
        //当裁剪面板关闭
        if (vm.cropperInstance != null) {
          vm.cropperInstance.destroy();
        }
        vm.cropperInstance = null;
        // crop_modal.off('hidden.bs.modal');//去除绑定
        vm.isCropModalVisible = false;
      });
      crop_modal.show();
    },
    onOk() {
      // let modal = $('#crop-modal');
      let modalEl = document.getElementById('crop-modal');
      let modal = bootstrap.Modal.getInstance(modalEl);
      if (!modal) {
        return;
      } else {
        modal.hide();
      }

      // 获得裁剪数据
      let cropData = this.cropperInstance.getData();

      //test
      let canvas_data = this.cropperInstance.getCanvasData();
      let cropcanvas_data = this.cropperInstance.getCroppedCanvas();
      let currentConfigIndex = this.currentCfgIndex;

      // console.log("currentConfigIndex:" + currentConfigIndex);
      // console.log("Crop  onOk ------ ");
      // console.dir(this.cropBoxConfig);

      let scalewidth = this.cropBoxConfig[currentConfigIndex].width;
      let scaleheight = this.cropBoxConfig[currentConfigIndex].height;

      // console.log("cropboxwidth:" + scalewidth + " cropboxheight:" + scaleheight);

      let cropBox = {
        top: parseInt(cropData.y),
        left: parseInt(cropData.x),
        width: parseInt(cropData.width),
        height: parseInt(cropData.height),
        scaleheight: scaleheight,
        scalewidth: scalewidth
      };
      let canvas = this.cropperInstance.getCroppedCanvas({
        width: this.cropBoxConfig[currentConfigIndex].width * 10,
        height: this.cropBoxConfig[currentConfigIndex].height * 10
      });
      let base64 = canvas.toDataURL("image/jpeg");
      let file = base64ToFile(base64, `${new Date().getTime().toString()}.jpg`);
      this.$emit("ok", {
        base64,
        file,
        cropBox
      });
    },
    // 点击宽高比图片
    onSelectSquare() {
      this.currentCfgIndex = 0;
      this.cropBoxConfig[0].width = this.crop_resizeSquare.width;
      this.cropBoxConfig[0].height = this.crop_resizeSquare.height;
      if (this.cropperInstance != null) {
        this.cropperInstance.setAspectRatio(1);
      }
      document.getElementById('crop_resizeSquare').classList.add('highlight');
      document.getElementById('crop_horizontal').classList.remove('highlight');
      document.getElementById('crop_vertical').classList.remove('highlight');
    },
    onSelectHorizontal() {
      this.currentCfgIndex = 1;
      this.cropBoxConfig[1].width = this.crop_horizontal.width;
      this.cropBoxConfig[1].height = this.crop_horizontal.height;
      if (this.cropperInstance != null) {
        this.cropperInstance.setAspectRatio(this.crop_horizontal.width / this.crop_horizontal.height);
      }
      document.getElementById('crop_resizeSquare').classList.remove('highlight');
      document.getElementById('crop_horizontal').classList.add('highlight');
      document.getElementById('crop_vertical').classList.remove('highlight');
    },
    onSelectVertical() {
      this.currentCfgIndex = 2;
      this.cropBoxConfig[2].width = this.crop_vertical.width;
      this.cropBoxConfig[2].height = this.crop_vertical.height;
      if (this.cropperInstance != null) {
        this.cropperInstance.setAspectRatio(this.crop_vertical.width / this.crop_vertical.height);
      }
      document.getElementById('crop_resizeSquare').classList.remove('highlight');
      document.getElementById('crop_horizontal').classList.remove('highlight');
      document.getElementById('crop_vertical').classList.add('highlight');
    },
    // 调整modal-footer-image的高度：
    // 基于容器高度的20%，并限制在 [56px, 120px]，保证小图时按钮不至于过小
    adjustModalFooterImageHeight() {
      const container = document.getElementById('crop-container');
      if (!container) return;
      const h = container.clientHeight || 0;
      const ratio = 0.20; // 从 15% 提升到 20%
      const minH = 56;
      const maxH = 100;
      let target = h * ratio;
      target = Math.max(minH, Math.min(maxH, target));
      $('.modal-footer-image').css('height', `${target}px`);
    }
  }
};